// Copyright (c) 2017 Deere & Company

import AuditResultModal, {getDefaultState as getAuditResultModalDefaultState} from '../state/audit-result-modal';
import actions from '../../actions-list';

const updateProperty = (state, action) =>
    AuditResultModal.update(state, {
        [action.property]: {
            $set: action.value
        }
    });

const reset = () => getAuditResultModalDefaultState();

export default (state = getAuditResultModalDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_AUDIT_SUMMARY_REPORT_AUDIT_RESULT_MODAL]: reset,
        [actions.UPDATE_AUDIT_SUMMARY_REPORT_AUDIT_RESULT_MODAL]: updateProperty
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/audit-summary/reducers/audit-result-modal.js